import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function EligibilityNumber() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Eligibility Number</p>
                <h1>Eligibility Number</h1>
                <p>Information on obtaining your eligibility number from Savitribai Phule Pune University.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>What is an Eligibility Number?</h2>
                    <p>An <strong>Eligibility Number</strong> is issued by Savitribai Phule Pune University (SPPU) to students who have passed their qualifying examination from a board other than the Maharashtra State Board (e.g., CBSE, ICSE, or boards from other states). It is mandatory for enrollment at SPPU-affiliated colleges.</p>
                </div>
                <div className="info-card">
                    <h2>Who Needs It?</h2>
                    <ul>
                        <li>Students who have completed 12th from <strong>outside Maharashtra</strong> (CBSE, ICSE, etc.).</li>
                        <li>Students transferring from another university to SPPU-affiliated institutions.</li>
                        <li>Students with foreign qualifications seeking admission.</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>How to Apply</h2>
                    <ol style={{ paddingLeft: '1.4rem', lineHeight: 2 }}>
                        <li>Fill the Eligibility Form available at the college office.</li>
                        <li>Attach original 10th &amp; 12th marksheets + migration certificate.</li>
                        <li>Submit the form with the prescribed fee at the college admission office.</li>
                        <li>The college forwards the application to SPPU on your behalf.</li>
                        <li>Once approved, the eligibility number is issued within 15–30 working days.</li>
                    </ol>
                </div>
                <div className="info-card">
                    <h2>Contact</h2>
                    <p>For guidance, contact the college admission office: <a href="tel:02488230438" style={{ color: '#2d6a4f' }}>(02488) 230438</a> or email <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a>.</p>
                    <div className="ext-links">
                        <a href="https://www.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 SPPU Official Website</a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default EligibilityNumber;
